<template>
    <el-form :inline="true" class="demo-form-inline" :label-position="labelPosition" ref="myForm">
        <el-form-item label="Type">
            <el-select v-model="type" placeholder="Please select type" style="width:200px;">
            <el-option v-for="option in typeOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="Species">
            <el-select v-model="species" placeholder="Please select species" style="width:200px;">
            <el-option v-for="option in speciesOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="Tissue">
          <el-select v-model="tissue" placeholder="Please select tissue" style="width:200px;">
            <el-option v-for="option in filteredTissueOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
        <el-button class="search-button" size="small" type="primary" @click="handleSearch" style="width:200px;">search</el-button>
      </el-form-item>
      <el-form-item>
        <el-button class="search-button" size="small" type="primary" @click="resetForm" style="width:200px;">reset</el-button>
      </el-form-item>
    </el-form>
</template>

<script>
export default {
    data() {
        return {
        labelPosition: 'top',
        type:'Compartment',//记得和Relationship1中的created一致
        species: 'mouse',//记得和Relationship1中的created一致
        tissue: 'PS',//记得和Relationship1中的created一致
        typeOptions: [
                { label: 'Compartment', value: 'Compartment' },
                { label: 'TAD', value: 'TAD' },
                { label: 'Loop', value: 'Loop' }
        ],
        speciesOptions: [
            { label: 'human', value: 'human' },
            { label: 'mouse', value: 'mouse' }
        ],
        tissueOptions: [
            { label: 'PS', value: 'PS', species: ['mouse'] },
            { label: 'RS', value: 'RS', species: ['mouse'] },
            { label: '0d_ESC', value: '0d_ESC', species: ['human'] },
            { label: '2d_mesoderm', value: '2d_mesoderm', species: ['human'] },
            { label: '5d_cardiac_mesoderm', value: '5d_cardiac_mesoderm', species: ['human'] },
            { label: '7d_cardiac_progenitor_cells', value: '7d_cardiac_progenitor_cells', species: ['human'] },
            { label: '15d_primitive_cardiomyocite', value: '15d_primitive_cardiomyocite', species: ['human'] },
            { label: '80d_ventricular_cardiomyocyte', value: '80d_ventricular_cardiomyocyte', species: ['human'] },
        ],
        };
    },
    computed: {
        filteredTissueOptions() {
        return this.tissueOptions.filter(option => option.species.includes(this.species));
        }
    },
    watch: {
        species(newSpecies) {
        if (newSpecies === 'human') {
            this.tissue = '0d_ESC';
        } else {
            this.tissue = 'PS';
        }
        }
    },
    methods: {
        handleSearch() {
            if (!this.species || !this.tissue || !this.type) {
                this.$message.error('Please complete the input field.');
                return;
            }
            const params = {
                Type: this.type,
                Species: this.species,
                Tissue: this.tissue,
            };
            this.$emit('search', params); // 触发名为'search'的事件，并传递参数
        },
        resetForm() {
            this.type = '';
            this.species = '';
            this.tissue = '';
        },
    },
};
</script>

<style scoped>
.demo-form-inline {
    font-weight: bold;
    display: flex;
    flex-direction: column;
    margin-left: 20px;
}
.search-button {
    color:#F1F7E7;
    font-size: medium;
    float: left;
    background-color: #2C3E50;
    width: 100px;
    border: 1px solid #2C3E50; /* 设置边框为与背景色一致 */
}
</style>


// WEBPACK FOOTER //
// src/components/3d/Threeselect.vue